"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// GLOBAL COLORS
const style = "normal";
const brand = "#002D5A";
const headerTextColor = "#FFF";
const headerBackgroundColor = brand;
const mainInfoPortrait = headerTextColor;
const mainInfoLandscape = brand;
const fontFamily = `
@font-face{
    font-family-base: 'GillSansMTPro';
}

@font-face{ 
    font-family: 'GillSansMTPro';
    src: url('/fonts/gillsans/gillsans-pro-book/gillsans-pro-book.eot') format('embedded-opentype');
    src: url('/fonts/gillsans/gillsans-pro-book/gillsans-pro-book.ttf') format('tff'),
            url('/fonts/gillsans/gillsans-pro-book/gillsans-pro-book.woff') format('woff'),
            url('/fonts/gillsans/gillsans-pro-book/gillsans-pro-book.woff2') format('woff2');
    font-weight: 400;
    font-style: normal;
}

@font-face{ 
    font-family: 'GillSansMTPro';
    src: url('/fonts/gillsans/gillsans-pro-medium/gillsans-pro-medium.eot') format('embedded-opentype');
    src: url('/fonts/gillsans/gillsans-pro-medium/gillsans-pro-medium.ttf') format('tff'),
            url('/fonts/gillsans/gillsans-pro-medium/gillsans-pro-medium.woff') format('woff'),
            url('/fonts/gillsans/gillsans-pro-medium/gillsans-pro-medium.woff2') format('woff2');
    font-weight: 700;
    font-style: normal;
}

@font-face{ 
    font-family: 'GillSansMTPro';
    src: url('/fonts/gillsans/gillsans-pro-bold/gillsans-pro-bold.eot') format('embedded-opentype');
    src: url('/fonts/gillsans/gillsans-pro-bold/gillsans-pro-bold.ttf') format('tff'),
            url('/fonts/gillsans/gillsans-pro-bold/gillsans-pro-bold.woff') format('woff'),
            url('/fonts/gillsans/gillsans-pro-bold/gillsans-pro-bold.woff2') format('woff2');
    font-weight: 900;
    font-style: normal;
}

@font-face{ 
    font-family: 'GillSansMTPro';
    src: url('/fonts/gillsans/gillsans-pro-light/gillsans-pro-light.eot') format('embedded-opentype');
    src: url('/fonts/gillsans/gillsans-pro-light/gillsans-pro-light.ttf') format('tff'),
            url('/fonts/gillsans/gillsans-pro-light/gillsans-pro-light.woff') format('woff'),
            url('/fonts/gillsans/gillsans-pro-light/gillsans-pro-light.woff2') format('woff2');
    font-weight: 200;
    font-style: normal;
}

html {
    font-family: "GillSansMTPro", sans-serif;
}
`;
exports.default = {
    brand,
    mainInfoPortrait,
    mainInfoLandscape,
    headerTextColor,
    headerBackgroundColor,
    fontFamily,
    style,
};
